<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <v-dialog
      v-model="dialog"
      max-width="90vh"
      scrollable
      :retain-focus="false"
      persistent
    >
      <v-card height="100%">
        <v-toolbar color="primary" dark>{{ formTitle }}
          
          <v-btn
            v-show="editInvestigation" 
            small 
            fab 
            @click="close" class="ml-auto">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>

        <v-card-text>
          <v-row class="mt-3">
            <v-col cols="12" md="6">
              <v-datetime-picker
                v-model="newResponseDate"
                :text-field-props="textFieldProps"
                
                :time-picker-props="startTimeProps"
                time-format="hh:mm a"
                date-format="MM/dd/yyyy"
                label="Response Date"
              ></v-datetime-picker>
            </v-col>
            <!-- <v-col cols="12" md="3">
              <v-text-field
                label="Response Time"
                v-model="newResponseTime"
                outlined
              ></v-text-field>
            </v-col> -->
            <v-col cols="12" md="6">
              <v-select
                label="Entity"
                :items="entities"
                v-model="newEntity"
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="newResponse"
                label="Response"
                outlined
              ></v-textarea>
            </v-col>
            <!-- <v-col cols="12" md="3">
                <v-text-field
                  label="Time Between Response"
                  v-model="newResponseDifference"
                ></v-text-field>
            </v-col> -->
          </v-row>

          <v-row class="mt-1">
            <v-col cols="12" md="12">
              
                <v-file-input   
                  v-model="newDocument"                             
                  class="pa-2"
                  label="Upload Documentation"
                  filled
                  multiple
                  prepend-icon="mdi-camera"
                  accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  @change="fileSelected"
                  show-size
                >
                  <template #selection="{ text, index }">
                    <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
                  </template>
                </v-file-input>
              
            </v-col>

            <v-col cols="12"
              v-for="doc in newDocuments"
              :key="doc.id"
            >
              <div v-if="doc.ext !='pdf' ">
                <v-chip
                  class="ma-2"
                  color="pink"
                  label
                  text-color="white"
                >
                  <v-icon left>
                    mdi-label
                  </v-icon>
                  {{ doc.name }}
                </v-chip>
                <v-img
                  max-height="480"
                  max-width="550"
                  :src="doc.aws"  
                ></v-img>
              </div>
              <div v-if="doc.ext =='pdf' ">
                <load-pdf 
                  :pdfFile="doc.aws"
                  :pdfName="doc.name"
                />
              </div>
            </v-col>
          </v-row>

          <v-row class="mt-n8">
            <v-col cols="12" md="12">
              <v-checkbox
                v-model="checkedSignature"
                label="Signature"
                hide-details
                @change="addSignature($event)"
              ></v-checkbox>
              <v-text-field v-model="newSignature"></v-text-field>
            </v-col>
          </v-row>

        </v-card-text>

        <v-card-actions>
            
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            :color="editInvestigation ? 'blue darken-1' : '#259647'"
            @click="editInvestigation ? onUpdateItem() : onAddItem()"
          >
            <div class="text-caption text-sm-body-1">
              {{ editInvestigation ? "Update" : "Save" }}
            </div>
          </v-btn>
          <v-btn color="blue darken-1" text @click="close">
            <div class="text-caption text-sm-body-1">Cancel</div></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ClientNav />

    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <!-- <investigation-side 
          :investigationItemData="$store.state.investigations.items" 
          :investigationID="investigationID"
        /> -->
        <v-card class="pa-2" max-width="374">
        <v-sheet>
          <v-card-title>Investigation Details</v-card-title>

          <v-card-text>
            <div class="text-center text-h4 green--text">
              Average Reponse Time
            </div>
            
            <div class="mt-4">
              Opened at: <b>{{ investigationOpenedAtFormatted }}</b>
              <br /><span v-show="$store.state.investigations.CloseOut">
              Closed at: <b>{{ closedAtFormatted }}</b>
              </span>
            </div>

            <div class="mt-4" v-show="stateEntityATR.hasResponse">
              <p class="my-0 font-weight-bold">State Entity</p>
              <v-divider class="my-0"></v-divider>
              <p class="my-0">Response per day: {{ stateEntityATR.responseFrequency }}</p>
              <p class="my-0">Average Response Time: {{ stateEntityATR.responseSpeed }} (hours)</p>
            </div>

            <div class="mt-4" v-show="redHeadSupportsATR.hasResponse">
              <p class="my-0 font-weight-bold">Redhead Supports</p>
              <v-divider class="my-0"></v-divider>
              <p class="my-0">Response per day: {{ redHeadSupportsATR.responseFrequency }}</p>
              <p class="my-0">Average Response Time: {{ redHeadSupportsATR.responseSpeed }} (hours)</p>
            </div>

            <v-divider class="mt-3 mb-2"></v-divider>
            <div class="text-center">
              {{ totalHours }}
            </div>
            <div class="text-center">
              Investigation Duration (in days)
            </div>
            
          </v-card-text> 
          
        </v-sheet>

        <v-divider class="mt-5"></v-divider>

        <v-card-text class="mt-3">
          <v-list-item class="grow ml-n5">
            <v-icon class="mr-1">
              mdi-calendar-month
            </v-icon>
            <span class="subheading mr-2">Date Period</span>
            <v-row align="center" justify="end">
              <span class="subheading">{{ datePeriod }}</span>
            </v-row>
          </v-list-item>
          <v-list-item class="grow ml-n5">
            <v-icon class="mr-1">
              mdi-finance
            </v-icon>
            <span class="subheading mr-2">Status</span>
            <v-row align="center" justify="end">
              <span class="subheading">{{
                $store.state.investigations.CloseOut ? "Close Out" : "Active"
              }}</span>
            </v-row>
          </v-list-item>
        </v-card-text>
      </v-card>
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-row dense>
          <v-col cols="12" md="12">
            <v-card elevation="0" outlined>
              <v-data-table
                :headers="headers"
                sort-asc
                :items="investigations"
                :item-class="rowColor"
                loading-text="Loading Investigations"
                height="475"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-card-actions>
                      <v-list-item class="grow">
                        <v-list-item-avatar color="grey darken-3">
                          <v-img
                            class="elevation-6"
                            alt=""
                            :src="$store.state.clients.client.Image"
                          ></v-img>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title>{{$store.state.clients.client.Name}}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                      :color="!$store.state.investigations.CloseOut ? '#2b3990' : 'red'"
                      dark
                      class="mb-2 mt-2"
                      @click="!$store.state.investigations.CloseOut ? showAdd() : ''"
                    >
                    <v-icon v-if="!$store.state.investigations.CloseOut" left
                      >add</v-icon
                    >
                    {{
                      $store.state.investigations.CloseOut
                        ? "Closed"
                        : "New Log"
                    }}</v-btn
                  >
                  </v-toolbar>
                </template>
                
                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="viewInvestigationLog(item)">
                    mdi-eye
                  </v-icon>
                  <v-icon
                    small
                    @click="
                      deleteInvestigationLog(item);
                      $event.stopPropagation();
                    "
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <Foot />
  </div>
</template>

<script>
/*eslint-disable */
import axios from "axios";
import moment from "moment";
import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import Foot from "../../components/Footer";
import InvestigationSide from "@/components/investigations/InvestigationSide";
import renameFileHelper from '../../mixins/renameFileHelper';
import LoadPdf from '@/components/LoadPDF.vue';
import { mapMutations, mapState, mapGetters, mapActions} from "vuex"
import { setUserTz, tz } from "../../../utils/timezone";

const url = require("../../client_config/config").url;

export default {
  mixins: [renameFileHelper],
  components: {
    ClientNav,
    ClientSide,
    InvestigationSide,
    Foot,
    LoadPdf
  },
  data() {
    return {
      dialog: false,
      show: null,
      search: "",
      headers: [
        {
          text: "Reponse Date",
          align: "start",
          sortable: true,
          value: "ResponseDate",
        },
        { text: "Response", value: "Response" },
        { text: "Entity", value: "Entity" },
        { text: "Staff Signature", value: "StaffSignature" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      investigations: [],
      entities: [
        "Redhead Supports",
        "State Entity"
      ],
      loading: false,
      selection: 1,
      datePeriod: "",
      clientID: this.$route.params.clientID,
      investigationID: this.$route.query.investigationID,
      investigationLogID: "",
      investigationOpenedAt: null,
      newItem: false,
      newResponseDate: moment().toDate(),
      newEntity: "",
      newResponse: "",
      newResponseTime: "",
      newResponseDifference: "",
      newSignature: "",
      newClientSignature: "",
      newClient: "",
      newStaff: "",
      signaturepop2: false,
      newSigned: "",
      newInvestigation: false,
      titleForm: "New Investigation Log",
      uploadImg: "",
      staff: localStorage.getItem("Name"),
      msg: false,
      text: "",
      signed: false,
      checkedSignature: false,
      editInvestigation: false,
      newImage: '',
      imgSelected: '',
      newUpload: '',
      uploadFile: "",
      newDocument: null,
      newDocuments: [],
      earliestDate: "",
      latestDate: "",
      datePeriod: "",
      time: "",
      average: 0,
      divider: 0,
      closeOut: false,
      maxDate: "",
      minDate: "",
      totalHours: "",
      averageTime: "",
      textFieldProps: {
        appendIcon: "event"
      },
      startDateProps: {
        min: moment(new Date()).format("YYYY-MM-DD")
      },
      startTimeProps: {
        ampmInTitle: true
      },
      endDateProps: {
        min: moment(new Date()).format("YYYY-MM-DD")
      },
      endTimeProps: {
        ampmInTitle: true
      },
      activePicker: false,
      timeDiffs:[],
      stateEntityATR: {
        responseFrequency: null,
        responseSpeed: null,
        hasResponse: false
      }, 
      redHeadSupportsATR: {
        responseFrequency: null,
        responseSpeed: null,
        hasResponse: false
      }, 
      closedAt : moment()
    };
  },

  created() {
    this.getInvestigation();
    this.getInvestigationLogs();
    
    if (this.$store.state.clients.client === null) {
      this.getClientInfo(this.clientID);
    }
  },

  watch: {
    startDatetime: function(nval) {
      this.endDatetime = new Date(
        new Date().setTime(nval.getTime() + 8 * 60 * 60 * 1000)
      );
      this.endDateProps.min = moment(nval).format("YYYY-MM-DD");
      this.endTimeProps.min = moment(nval).format("HH:mm");

      this.getDefaultStaff(nval, this.endDatetime);
    
      },
  },

  computed: {
    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    }, 
    clientName() {
      // `this` points to the component instance
      return this.$store.state.clients.client.Name;
    },
    formTitle(){
      return this.editInvestigation ? 'Edit Investigation Log':'New Investigation Log';
    }, 

    investigationOpenedAtFormatted() {
      return tz(this.investigationOpenedAt, this.userTimezone).format("YYYY-MM-DD");
    }, 

    closedAtFormatted() {
      return tz(this.closedAt, this.userTimezone).format("YYYY-MM-DD")
    }
    
  },

  methods: {
    ...mapActions({
      getClientInfo: "clients/getClient",
    }),

    getMaxDate(date) {
      let moments = date.map((x) => moment(x)),
        maxDate = moment.max(moments).format("YYYY-MM-DD");
      return maxDate;
    },
    getMinDate(date) {
      let moments = date.map((x) => moment(x)),
        minDate = moment.min(moments).format("YYYY-MM-DD");
      return minDate;
    },

    // fetch() {
    //   this.getClientInvestigations(this.investigationID)
    // },

    async getInvestigation() {
      await axios.get(`${url}/investigations/${this.clientID}/investigation/${this.investigationID}`).then(res => {
        if (res.data.investigation.createdAt) {
          this.investigationOpenedAt = moment(res.data.investigation.OpenDate);
        }
      });
    },

    showAdd() {
      this.dialog = true;
      // this.newResponseTime = item.ResponseTime;
      this.newEntity = "";
      this.newResponse = "";
      this.newResponseDifference = "";
      this.newSignature = "";
      this.checkedSignature = false;
      this.newDocuments = [];
      this.newDocument = null;
    },

    async getInvestigationLogs() {
      await axios.get(`${url}/investigationLogs/${this.investigationID}`).then(res => {
        this.investigations = [];
        let tempData = [];
        let last = 0;
        
        tempData = res.data.investigationLogs;
        
        const byEntity = res.data.investigationLogs.reduce((result, log) => {
          const { Entity } = log;
          if (!result[Entity]) {
            result[Entity] = [];
          }
          result[Entity].push(moment(log.ResponseDate));
          return result;
        }, {});

        if (byEntity[`State Entity`]) {
          this.stateEntityATR.hasResponse = true;

          const responsePerDay = this.calculateResponseFrequency(byEntity[`State Entity`]);
          const numDays = Object.keys(responsePerDay).length;

          let sumResponses = 0;
          for (let key in responsePerDay) {
            sumResponses += responsePerDay[key];
          }

          this.stateEntityATR.responseFrequency = (sumResponses / numDays).toFixed(2);

          byEntity[`State Entity`].push(this.investigationOpenedAt);
          this.calculateResponseTime(byEntity[`State Entity`]);
          let sumHours = 0;
          const diffLength = this.timeDiffs.length;
          for (let i=0; i<diffLength; i++) {
            sumHours += this.timeDiffs[i];
          }
          this.stateEntityATR.responseSpeed = (sumHours / diffLength).toFixed(2);
        }

        if (byEntity[`Redhead Supports`]) {
          this.redHeadSupportsATR.hasResponse = true;

          const responsePerDay = this.calculateResponseFrequency(byEntity[`Redhead Supports`]);
          const numDays = Object.keys(responsePerDay).length;

          let sumResponses = 0;
          for (let key in responsePerDay) {
            sumResponses += responsePerDay[key];
          }
          
          this.redHeadSupportsATR.responseFrequency = (sumResponses / numDays).toFixed(2);
          byEntity[`Redhead Supports`].push(this.investigationOpenedAt);
          this.timeDiffs = [];
          this.calculateResponseTime(byEntity[`Redhead Supports`]);
          let sumHours = 0;
          const diffLength = this.timeDiffs.length;
          for (let i=0; i<diffLength; i++) {
            sumHours += this.timeDiffs[i];
          }
          this.redHeadSupportsATR.responseSpeed = (sumHours / diffLength).toFixed(2);
        }
        //this.calculateResponseTime(byEntity[`Redhead Supports`]);
        for (var i = 0; i < tempData.length; i++) {
          // convert date base on user timezone
          tempData[i].ResponseDate = moment(tempData[i].ResponseDate).format(
            "MM/DD/YYYY h:mm A"
          );
          this.investigations.push(tempData[i]);

          last = this.investigations.slice(-1)[0].ResponseDate
          let difference = moment(tempData[i + 1]).diff(moment(tempData[i].ResponseDate))
          let duration = moment.duration(difference).hours()
          this.averageTime = duration.toFixed(2) / this.investigations.length
        }

        if (this.$store.state.investigations.CloseOut) {
          this.closedAt = moment(this.investigations[0].ResponseDate);
        }

        this.totalHours = this.closedAt.diff(this.investigationOpenedAt, 'days');

        if(this.investigations) return;
        

        /*
        let earliestDate = this.investigations[0].ResponseDate;
        let latestDate = this.investigations.slice(-1)[0].ResponseDate;

        console.log(earliestDate + " earliest")
        console.log(latestDate + " latest")

        let Test = moment(latestDate).diff(moment(earliestDate))

        this.totalHours = moment.duration(Test).asDays().toFixed(2)
        this.averageTime = this.averageTime.toFixed(2)

        if ((earliestDate && latestDate) == "Invalid Date") {
          return null;
        }

        if (Date.parse(earliestDate) == Date.parse(latestDate)) {
          return (this.datePeriod = `${tz(earliestDate, this.userTimezone).format(
            "DD MMM"
          )} - Present`);
        }

        this.datePeriod = `${tz(earliestDate, this.userTimezone).format(
          "DD MMM"
        )} - ${tz(latestDate, this.userTimezone).format("DD MMM")}`;
        for(var i = 0; i < this.investigations.length; i++){
          this.investigations[i].ResponseDate = moment(this.investigations[i].ResponseDate).format("MM/DD/YYYY h:mma")
        }*/   

      })
    },

    deleteInvestigationLog(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this investigation?") &&
      this.investigationDelete(id);
    },

    investigationDelete(id) {
      axios.delete(`${url}/investigationLogs/${id}`)
      .then((response) => {
        this.getInvestigationLogs();
        if (response.status == 400) {
          response.json().then(function(data) {
            return data.msg;
          });
        }
        this.msg=true;
        this.text="The investigation has been deleted successfully.";
      });
    },

    rowColor(item) {
      return item.Entity == "Redhead Supports" ? "Green" : "Black";
    },

    viewInvestigationLog(item) {
      this.editInvestigation = true;
      this.dialog = true;
      this.investigationLogID = item._id;
      this.newResponseDate = item.ResponseDate;
      // this.newResponseTime = item.ResponseTime;
      this.newEntity = item.Entity;
      this.newResponse = item.Response;
      this.newResponseDifference = item.ResponseDifference;
      this.newSignature = item.StaffSignature
        ? ((this.checkedSignature = true), item.StaffSignature)
        : ((this.checkedSignature = false), "");

      if(item.documents.length > 0){
        const tempData = [];
        for(let i = 0; i < item.documents.length ; i++){
          let fileExt = item.documents[i].AWSLink.split('.').pop();
          tempData.push({
            name: item.documents[i].Name,
            id:  item.documents[i]._id,
            aws: item.documents[i].AWSLink,
            ext: fileExt
          });
        }
        this.newDocuments = tempData;
      }
      
    },

    async onAddItem() {
      var req_body = {
        ResponseDate: this.newResponseDate,
        Entity: this.newEntity,
        Involved: this.newInvolved,
        Response: this.newResponse,
        StaffSignature: this.newSignature,
        InvestigationID: this.investigationID,
        ClientID: this.clientID,
      }
      await axios.post(`${url}/investigationLogs`, req_body).then(res => {
        if (!res.data.success){
          res.json().then(function(data) {
            this.msg = true;
            this.text=res.data.message
          })
        }

        this.msg =true;
        this.text ="The new investigation log has been added successfully.";
        this.investigationLogID = res.data.investigationLogs._id
      })
      if (this.uploadFile !== null && this.uploadFile !== undefined) {
        await this.saveFile();
      }
      await this.getInvestigationLogs();
      this.close()
    },

    async onUpdateItem() {
      var req_body = {
        ResponseDate: this.newResponseDate,
        Entity: this.newEntity,
        Response: this.newResponse,
        ResponseDifference: this.newResponseDifference,
        StaffSignature: this.newSignature,
      };

      await axios.put(`${url}/investigationLogs/${this.investigationLogID}`, req_body).then(res => {
        
        if (res.status == 400){
          res.json().then(function(data) {
            this.msg = true;
            this.text=data.msg
          })
        }
        this.msg =true;
        this.text ="The investigation has been updated successfully.";
       
      })
      if (this.uploadFile !== null && this.uploadFile !== undefined) {
        await this.saveFile();
      }
      await this.getInvestigationLogs()
      this.close()
    },

    close() {
      this.dialog = false;
      this.editInvestigation = false;
      this.clear();
    },

    deleteChip(index) {
      // Prompt here with text if required
      this.newDocument.splice(index, 1)
      //this.files = this.previousFiles
    },

    clear() {
      this.newResponseDate = "";
      this.newEntity = "";
      this.newResponse = "";
      this.newResponseTime = "";
      this.newResponseDifference = "";
      this.newStaffSignature = ""; 
      this.newDocument = []
      this.newDocuments = []
    },

    addSignature(e) {
      if (!e) return (this.newSignature = "");
      this.newSignature = this.staff + " - " + new Date();
      this.signed = true;
    },

    async fileSelected(e) {
      this.uploadFile = await this.renameFileHelper(e, this.clientName, "Investigation");
      //this.uploadFile=e;
    },

    async saveFile() {
      this.message = "";
      for (let i = 0; i < this.uploadFile.length; i++) {
        await this.uploadFiles(this.uploadFile[i]);
      }
      await this.getInvestigationLogs();
    },

    async uploadFiles(file) {
      const formData = new FormData();
      formData.append('investigation', file);
      var ct = { headers:{"content-type" : "multipart/form-data"}};
      await axios.post(`${url}/investigationLogs/fileuploader/${this.investigationLogID}/${this.clientID}`,formData, ct)
      .then(res => {
        if(res){
          //this.getInvestigationLogs();
        }
      })
      .catch(err => {
        console.log(err);
      });
    },

    /**
      @param array of moments
    */
    calculateResponseTime(logs) {
      const logLength = logs.length;
      
      for (let i = 0; i < logLength - 1; i++) {
        if (logs[i].isSameOrAfter(logs[i+1])) 
          this.timeDiffs.push(logs[i].diff(logs[i+1], 'hours', true));
      }

      return;
    },

    calculateResponseFrequency(logs){
      const logLength = logs.length;

      return logs.reduce((result, log) => {
          const logDate = log.format('YYYY-MM-DD');
          if (!result[logDate]) {
            result[logDate] = 0;
          }
          result[logDate] += 1;
          return result;
        }, {});
    }
  },
};
</script>
